import PortalIdParser from 'PortalIdParser';
const getSubmissionsAppUrl = (portalId = PortalIdParser.get()) => `/submissions/${portalId}`;
export default getSubmissionsAppUrl;